// Application Constants

export const FILE_UPLOAD_CONFIG = {
  maxSize: 10 * 1024 * 1024, // 10MB
  acceptedTypes: {
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'text/plain': ['.txt']
  }
};

export const TRANSCRIPTION_CONFIG = {
  confidenceThreshold: 0.6,
  questionDetectionKeywords: [
    'what', 'how', 'why', 'when', 'where', 'who',
    'tell me', 'describe', 'explain', 'can you',
    'would you', 'could you', 'have you',
    'do you', 'are you', 'will you'
  ],
  maxTranscriptionLength: 1000,
  minTranscriptionLength: 10
};
